import { z } from 'zod'
import { api } from '@/shared/api/client'
import { instantSchema } from '@/shared/api/schemas'

/** `WhatsAppSettingsDraft` dagi `@Pattern` lar bilan bir xil */
export const WHATSAPP_RULES = {
  phoneNumberId: /^[0-9]{5,32}$/,
  accessToken: /^[\x21-\x7E]{20,2048}$/,
  apiVersion: /^v[0-9]{1,3}\.[0-9]{1,2}$/,
} as const

const settingsSchema = z.object({
  source: z.enum(['DATABASE', 'CONFIG']),
  enabled: z.boolean(),
  businessPhone: z.string().nullish(),
  phoneNumberId: z.string().nullish(),
  accessTokenSet: z.boolean(),
  apiVersion: z.string().nullish(),
  defaultApiVersion: z.string().nullish(),
  updatedAt: instantSchema.nullish(),
})

const testResultSchema = z.object({
  status: z.enum(['SENT', 'INVALID_RECIPIENT', 'TEMPORARY_FAILURE', 'REJECTED']),
  providerMessageId: z.string().nullish(),
  detail: z.string().nullish(),
})

export interface WhatsAppSettings {
  /** `CONFIG` — panelda hali saqlanmagan, konfiguratsiya fayli ishlayapti */
  source: 'DATABASE' | 'CONFIG'
  enabled: boolean
  businessPhone: string | null
  phoneNumberId: string | null
  /** Token hech qachon qaytmaydi — faqat bor-yo'qligi */
  accessTokenSet: boolean
  apiVersion: string | null
  defaultApiVersion: string | null
  updatedAt: string | null
}

export interface WhatsAppSettingsDraft {
  enabled: boolean
  businessPhone: string | null
  phoneNumberId: string | null
  /** `null` — saqlangan token o'zgarmaydi */
  accessToken: string | null
  apiVersion: string | null
}

export type WhatsAppTestResult = z.infer<typeof testResultSchema>

function toSettings(raw: unknown): WhatsAppSettings {
  const parsed = settingsSchema.parse(raw)
  return {
    source: parsed.source,
    enabled: parsed.enabled,
    businessPhone: parsed.businessPhone ?? null,
    phoneNumberId: parsed.phoneNumberId ?? null,
    accessTokenSet: parsed.accessTokenSet,
    apiVersion: parsed.apiVersion ?? null,
    defaultApiVersion: parsed.defaultApiVersion ?? null,
    updatedAt: parsed.updatedAt ?? null,
  }
}

const PATH = '/api/notify/whatsapp/settings'

export async function fetchWhatsAppSettings(): Promise<WhatsAppSettings> {
  const response = await api.get<unknown>(PATH)
  return toSettings(response.data)
}

export async function saveWhatsAppSettings(draft: WhatsAppSettingsDraft): Promise<WhatsAppSettings> {
  const response = await api.put<unknown>(PATH, draft)
  return toSettings(response.data)
}

export async function resetWhatsAppSettings(): Promise<WhatsAppSettings> {
  const response = await api.delete<unknown>(PATH)
  return toSettings(response.data)
}

export async function sendWhatsAppTest(to: string): Promise<WhatsAppTestResult> {
  const response = await api.post<unknown>(`${PATH}/test`, { to })
  return testResultSchema.parse(response.data)
}
